import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findTemplateName = createAsyncThunk(
    "userTemplate/findTemplateName",
    async (template: string, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`${api.baseURL}form`, {
                params: {
                    populate: false,
                    select: "name",
                    where: {
                        id: template,
                    }
                }
            });
            return data[0].name;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);


        